import * as React from "react";

function SvgCancelImaging(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 34 34" fill="none" {...props}>
      <path d="M 2.83334 2.83325 H 12.83334 V 31.1666 H 2.83334 V 2.83325 Z" fill="#414042" />
      <path d="M 21.1667 2.83325 H 31.1667 V 31.1666 H 21.1667 V 2.83325 Z" fill="#414042" />
    </svg>
  );
}

export default SvgCancelImaging;
